import { SalePointIdValue } from '@/components/modules/Application/IberiaCards/_shared/types/SalePoint';
import { LastSalePointRepository } from '@/components/modules/Application/IberiaCards/modules/SalePointAndProduct/entities/LastSalePointRepository/LastSalePointRepository';
import { SESSION_LOCAL_STORAGE_PREFIX } from '@/utils/clearSessionLocalStorage';

export class LastSalePointLocalStorageRepository implements LastSalePointRepository {
  // Session prefixed so it is cleared on logout and the agent has to pick it again after logging in
  private readonly storageKey = `${SESSION_LOCAL_STORAGE_PREFIX}iberia_cards_stands_last_sale_point`;

  private getAll(): Record<string, SalePointIdValue> {
    try {
      const data = localStorage.getItem(this.storageKey);
      if (!data) return {};
      return JSON.parse(data);
    } catch (err) {
      if (err instanceof DOMException) {
        console.warn('Local storage read-access restricted');
        console.warn('Failed to getAll');
        return {};
      }
      throw err;
    }
  }

  public get(agentEmail: string): SalePointIdValue | undefined {
    return this.getAll()[agentEmail];
  }

  public set(agentEmail: string, salePointId: SalePointIdValue): void {
    try {
      localStorage.setItem(this.storageKey, JSON.stringify({ ...this.getAll(), [agentEmail]: salePointId }));
    } catch (err) {
      if (err instanceof DOMException) {
        console.warn('Local storage write-access restricted');
        console.warn('Failed to set');
        return;
      }
      throw err;
    }
  }
}
